/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'RACE_ETHNIC_GROUP_SKIN_COLOR',
              'SEX_GENDER',
              'RELIGION',
              'POLITICAL_OPINION',
              'NATIONAL_EXTRACTION',
              'SOCIAL_ORIGIN',
              'DISABILITY',
              'HIV_AIDS_STATUS_REAL_OR_PERCEIVED_',
              'SEXUAL_ORIENTATION',
              'PREGNANCY_MATERNITY_STATUS',
              'MARITAL_STATUS',
              'AGE',
              'NATIONALITY_FOREIGN_MIGRANT_WORKER_STATUS',
              'FAMILY_RESPONSIBILITIES',
              'OTHER',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    which_of_the_following_is_a_factor_in_decisions_on_promotion_or: valueSchema,
  },
}
